import React, {Component} from "react";
import FormLayout from "./FormLayout";
import Step0 from "./Step0";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import {withTranslation} from "react-i18next";
import {withRouter} from "react-router-dom";
import {withCookies} from "react-cookie";
import apiHelper from "../../utils/apiHelper";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

class RegisterPage extends Component {
  constructor(props) {
    super(props);


    // Set the initial input values
    this.state = {
      currentStep: 0, // Default is Step 0
      maxTicket: 3,
      giftList: "",
      planList: "",

      agreeTerms: false, //default value
      notReceivePromotion: false, //default value

      isExistingMember: false,
      firstName: "",
      lastName: "",
      gender: "0", //default value
      address: "",
      contactNumber: "",
      email: "",
      password: "",
      repassword: "",
      dob: null,
      occupation: "",

      canUpdateDob: true,

      plan: "1", //default value
      planlist: {},

      gift: {
        deliveryMethod: "2", //default value 0 pickup, 1 by post
        pickupLocation: "",
        // "details": [
        //   {
        //       "giftId":1,
        //       "quantity": 5
        //   },
        //   {
        //       "giftId":2,
        //       "quantity": 3
        //   }
        // ]
      },
      giftReady: false,
      isPromotionPeriod: undefined,

      shippingCostDelivery: "",
      shippingCostPickup: "",
      renewalDiscount: "",

      donationAmount: "0", //default value
      donationSendReceipt: false,

      errorMessage: {
        agreeTerms: "",
        notReceivePromotion: "",

        isExistingMember: "",
        firstName: "",
        lastName: "",
        gender: "",
        address: "",
        contactNumber: "",
        email: "",
        password: "",
        repassword: "",
        dob: "",
        occupation: "",

        ticket: "",
        pickupLocation: "",

        donationAmount: "",
        donationSendReceipt: "",
      },
    };

    // Bind the submission to handleChange()
    this.handleChange = this.handleChange.bind(this);
    this._next = this._next.bind(this);
    this._goto = this._goto.bind(this);
    this._prev = this._prev.bind(this);
    this._confirm = this._confirm.bind(this);
  }

  componentDidMount() {
    this.getPlanGiftList(false);
    const {t, i18n} = this.props;
    const {cookies, setCookie, removeCookie} = this.props;

    // is member, but neither renew nor resumepay -> renew
    if (cookies.cookies.token && !(this.props.renew || this.props.resumepay)) {
      this.props.history.push("/" + i18n.language + "/renew");
    }

    // is member, but expiry date is not set -> resumepay
    if (cookies.cookies.token && cookies.cookies.expiryDate === 'no') {
      this.props.history.push("/" + i18n.language + "/resumepay");
    }

    // is member and resumepay, but expiry date is set -> renew
    if (cookies.cookies.token && cookies.cookies.expiryDate !== 'no' && this.props.resumepay) {
      this.props.history.push("/" + i18n.language + "/renew");
    }

    // is member -> prefill
    if (cookies.cookies.token) {
      this.prefill(cookies.cookies.token);
    }
    // NOT member, but renew or resumepay -> register
    if (!cookies.cookies.token && (this.props.resumepay || this.props.renew)) {
      this.props.history.push("/" + i18n.language + "/register");
    }

  }

  componentDidUpdate(prevProps, prevState) {

    if (this.props.t !== prevProps.t) {
      this.getPlanGiftList(true);
    }

    if (this.state.isPromotionPeriod !== undefined && this.state.isPromotionPeriod !== prevState.isPromotionPeriod && this.props.renew) {
        this.protectRenewPage(this.state.isPromotionPeriod, this.props.cookies.cookies.expiryDate);
    }

  }

  prefill = (token) => {
    if (token) {
      var self = this;
      try {
        apiHelper
          .getMemberProfile(token)
          .then(function (response) {
            for (const [key, value] of Object.entries(response.data)) {
              self.setState((prevState) => ({
                ...prevState,
                [key]: String(value),
              }));
            }

            if (response.data.dob == "" || response.data.dob == null) {
              self.setState((prevState) => ({
                ...prevState,
                dob: null,
              }));
              self.setState((prevState) => ({
                ...prevState,
                canUpdateDob: true,
              }));
            } else {
              self.setState((prevState) => ({
                ...prevState,
                canUpdateDob: false,
              }));
            }

          })
          .catch(function (error) {
            console.log("member profile error");
            console.log(error);
          });

        apiHelper
          .getMemberCurrentPlan(token)
          .then(function (response) {
            var currentPlan = response.data == "" ? 1 : response.data.id;
            self.setState((prevState) => ({
              ...prevState,
              plan: currentPlan,
            }));
          })
          .catch(function (error) {
            console.log("member current-plan error");
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    }
  };

  // Use the submitted data to set the state
  handleChange(event, newGender) {
    if (event && event.target) {
      const {name, value, checked, ariaLabel, innerText} = event.target;
      var updatedValue = value;

      const checkboxes = [
        "agreeTerms",
        "notReceivePromotion",
        "donationSendReceipt",
        "isExistingMember"
      ];
      var isCheckbox = checkboxes.includes(name);
      if (isCheckbox) updatedValue = checked;

      const {t, i18n} = this.props;
      const genderLabel = [t("male"), t("female"), t("others")];
      var isGender = genderLabel.includes(innerText);
      if (isGender && newGender != null) {
        this.setState({
          gender: String(newGender),
        });
      }

      var isGift = name && name.includes("gift");

      if (!isGift) {
        this.setState({
          [name]: updatedValue,
        });
      } else {
        var substrings = name.split("-");
        if (!isNaN(substrings[1])) {
          this.setState((prevState) => ({
            gift: {
              ...prevState.gift,
              [name]: {
                ...prevState.gift[name],
                quantity: value,
              },
            },
          }));
        } else {
          this.setState((prevState) => ({
            gift: {
              ...prevState.gift,
              [substrings[1]]: value,
            },
          }));
        }
      }
    } else {
      //datepicker
      var date = event;
      var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

      var dd = String(firstDayOfMonth.getDate()).padStart(2, "0");
      var mm = String(firstDayOfMonth.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = firstDayOfMonth.getFullYear();

      firstDayOfMonth = yyyy + "-" + mm + "-" + dd;
      this.setState({
        dob: firstDayOfMonth,
      });
    }
  }

  // Trigger an alert on form submission
  handleSubmit = (event) => {
    event.preventDefault();
    const {email, username, password} = this.state;
    alert(`Your registration detail: \n 
      Email: ${email} \n 
      Username: ${username} \n
      Password: ${password}`);
  };

  nextPage = () => {
    let currentStep = this.state.currentStep;
    currentStep = currentStep + 1;
    this.setState({
      currentStep: currentStep,
    });
  };

  addErrMsg = (field, msg) => {
    this.setState((prevState) => ({
      errorMessage: {
        ...prevState.errorMessage,
        [field]: msg,
      },
    }));
  };

  emptyErrMsg = () => {
    this.setState({
      errorMessage: {
        "": "",
      },
    });
  };

  oneErrMsg = (field, msg) => {
    this.setState({
      errorMessage: {
        [field]: msg,
      },
    });
  };

  validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validatePassword = (password) => {
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
    return re.test(String(password));
  }

  validateContactNumber = (number) => {
    const re = /^[0-9]{8}$/;
    return re.test(String(number));
  }

  step0checking = () => {
    var err = 0;
    if (this.state.agreeTerms == "") {
      this.addErrMsg("agreeTerms", "tnc.agreeTermserror");
      err++;
    }
    return err;
  };

  step1checking = (renew, resumepay) => {
    var err = 0;
    var requiredfields = [
      "firstName",
      "lastName",
      "address",
      "contactNumber",
      "email",
      "dob",
    ];
    if (typeof renew === "undefined" || typeof resumepay !== "undefined") {
      requiredfields.push("password");
      requiredfields.push("repassword");
    }
    requiredfields.forEach((requiredfield) => {
      if (
        this.state[requiredfield] == "" ||
        this.state[requiredfield] == null
      ) {
        this.addErrMsg(requiredfield, requiredfield + ".mandatoryerror");
        err++;
      } else {
        if (requiredfield == "repassword") {
          if (this.state.password != this.state.repassword) {
            this.addErrMsg(requiredfield, requiredfield + ".mismatcherror");
            err++;
          } else {
            if (!this.validatePassword(this.state.password)) {
              this.addErrMsg(requiredfield, requiredfield + ".formaterror");
              err++;
            }
          }
        }

        if (requiredfield == 'contactNumber') {
          if (!this.validateContactNumber(this.state[requiredfield])) {
            this.addErrMsg(requiredfield, requiredfield + '.formaterror');
            err++;
          }
        }
        if (requiredfield == 'email') {
          if (!this.validateEmail(this.state[requiredfield])) {
            this.addErrMsg(requiredfield, requiredfield + '.formaterror');
            err++;
          }
        }
      }
    });
    return err;
  };

  step3checking = () => {
    var err = 0;
    var sum = 0;

    var gifts = this.state.gift;

    Object.keys(gifts).map(function (key) {
      var substrings = key.split("-");
      if (key.includes("gift") && !isNaN(substrings[1])) {
        sum = sum + parseInt(gifts[key].quantity);
      }
    });

    if (sum > this.state.maxTicket) {
      err++;
      this.addErrMsg("ticket", "cannotexceed");
    }

    if (sum < this.state.maxTicket) {
      err++;
      this.addErrMsg("ticket", "cannotbefewerthan");
    }

    if (gifts.deliveryMethod == "0" && gifts.pickupLocation == "") {
      err++;
      this.addErrMsg("pickupLocation", "pickuplocationmandatoryerror");
    }
    return err;
  };

  getPlanGiftList = (isLangUpdate) => {
    var self = this;
    try {
      const {t, i18n, cookies} = this.props;
      apiHelper
        .getPlanInfo(i18n.language, cookies.cookies.token)
        .then(function (response) {
          if (response.data.giftQuota) self.setState({maxTicket: response.data.giftQuota})
          if (response.data.insidePromotionPeriod) self.setState({isPromotionPeriod: true})
          else self.setState({ isPromotionPeriod: false })
          response.data.gift.forEach((element) => {
            var giftid = "gift-" + element["id"];

            if (!isLangUpdate) {
              self.setState((prevState) => ({
                gift: {
                  ...prevState.gift,
                  [giftid]: {
                    id: element["id"],
                    name: element["name"],
                    quantity: "0",
                    quota: element["quota"],
                  },
                },
              }));
            } else {
              self.setState((prevState) => ({
                gift: {
                  ...prevState.gift,
                  [giftid]: {
                    ...prevState.gift[giftid],
                    id: element["id"],
                    name: element["name"],
                  },
                },
              }));
            }

          });
          self.setState({
            giftList: response.data.gift,
          });

          response.data.plan.forEach((element) => {
            var planid = "plan-" + element["id"];
            self.setState((prevState) => ({
              planList: {
                ...prevState.planList,
                [planid]: {
                  id: element["id"],
                  name: element["name"],
                  price: element["price"],
                },
              },
            }));
          });
          self.setState({
            planList: response.data.plan,
          });
          self.setState({
            shippingCostPickup: response.data.shippingCostPickup,
            shippingCostDelivery: response.data.shippingCostDelivery,
          });
          self.setState({
            renewalDiscount: response.data.renewalDiscount,
          });
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          self.setState({
            giftReady: true,
          })
        })
    } catch (err) {
      console.log(err);
    } finally {
      // setLoading(false);
    }
  };

  protectRenewPage(isPromotionPeriod, expiryDate) {
    if (isPromotionPeriod) {
      apiHelper.getMemberInfo(this.props.cookies.cookies.token).then((response) => {
        if (!response.data.canClaimPromotionBenefit) {
          this.props.history.push("/profile");
        }
      }).catch(console.error)
    } else if (
        !dayjs().isBetween(dayjs(new Date(expiryDate)).subtract(2, 'week'), new Date(expiryDate), 'day', '[]')
        &&
        !dayjs().isAfter(new Date(expiryDate), 'day')
      ) {
        this.props.history.push("/profile");
      }
  }


  _next() {
    let currentStep = this.state.currentStep;
    var self = this;
    if (currentStep == 0) {
      self.emptyErrMsg();
      if (self.step0checking() == 0) {
        self.nextPage();
      }
    } else if (currentStep == 1) {
      self.emptyErrMsg();
      var err = self.step1checking(this.props.renew, this.props.resumepay);
      // check if contact number is unique
      if (!this.props.renew && !this.props.resumepay) {
        apiHelper
          .registerCheck(this.state.contactNumber)
          .then(function (response) {
            if (response.data.result) {
              if (err == 0) {
                self.nextPage();
              }
            } else {
              self.addErrMsg(
                "contactNumber",
                "contactNumber.registerederror"
              );
              err++;
            }
          })
          .catch(function (error) {
            self.addErrMsg(
              "contactNumber",
              "contactNumber.registerederror"
            );
            err++;
          });
      } else {
        if (err == 0) {
          self.nextPage();
        }
      }
    } else if (currentStep == 3) {
      self.emptyErrMsg();
      var err = self.step3checking();
      if (err == 0) {
        self.nextPage();
      }
    } else {
      self.nextPage();
    }
  }

  _prev() {
    let currentStep = this.state.currentStep;
    // If the current step is 2 or 3, then subtract one on "previous" button click
    currentStep = currentStep - 1;

    if (currentStep == 1) {
      this.setState({password: ""});
      this.setState({repassword: ""});
    }
    this.setState({
      currentStep: currentStep,
    });
  }

  _goto(step) {
    let currentStep = this.state.currentStep;
    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep + 1;
    this.setState({
      currentStep: step,
    });
  }

  _confirm() {
    const {t, i18n} = this.props;
    var gifts = this.state.gift;
    var details = [];
    Object.keys(gifts).map(function (key) {
      var substrings = key.split("-");
      if (key.includes("gift") && !isNaN(substrings[1])) {
        var detail = {
          giftId: gifts[key]["id"],
          quantity: gifts[key]["quantity"],
        };
        details.push(detail);
      }
    });

    var json = {
      address: this.state.address,
      agreeTerms: this.state.agreeTerms,
      contactNumber: this.state.contactNumber,
      dob: this.state.dob,
      donation: {
        amount: this.state.donationAmount,
        sendReceipt: this.state.donationSendReceipt,
      },
      email: this.state.email,
      firstName: this.state.firstName,
      gender: this.state.gender,
      gift: {
        deliveryMethod: this.state.gift.deliveryMethod, // 0 or 1, 0 is PICKUP, 1 is delivery
        address: this.state.gift.pickupLocation,
        details: details,
      },
      lastName: this.state.lastName,
      occupation: this.state.occupation,
      password: this.state.password,
      planId: this.state.plan,
      receivePromotion: !this.state.notReceivePromotion,
      isExistingMember: this.state.isExistingMember,
      lang: i18n.language
    };
    const {cookies, setCookie, removeCookie} = this.props;
    if (this.props.resumepay && cookies.cookies.token && cookies.cookies.expiryDate == "no") {
      // console.log("resume");
      apiHelper
        .resumePay(cookies.cookies.token, json)
        .then(function (response) {
          const form = document.createElement("form");
          form.method = "post";
          form.action = response.data.url;

          document.body.appendChild(form);
          form.submit();
        })
        .catch(function (error) {
          console.log(error);
        });
    } else if (this.props.renew && cookies.cookies.token) {
      // console.log("renew");
      apiHelper
        .renew(cookies.cookies.token, json)
        .then(function (response) {
          const form = document.createElement("form");
          form.method = "post";
          form.action = response.data.url;

          document.body.appendChild(form);
          form.submit();
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      // console.log("new");
      apiHelper
        .register(i18n.language, json)
        .then(function (response) {
          const form = document.createElement("form");
          form.method = "post";
          form.action = response.data.url;

          document.body.appendChild(form);
          form.submit();
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  // The "next" and "previous" button functions
  get previousButton() {
    let currentStep = this.state.currentStep;
    // If the current step is not 1, then render the "previous" button
    if (currentStep !== 1) {
      return (
        <button
          className="btn btn-secondary"
          type="button"
          onClick={this._prev}
        >
          Previous
        </button>
      );
    }
    // ...else return nothing
    return null;
  }

  // Render UI will go here...
  render() {
    return (
      <React.Fragment>
        <FormLayout
          currentStep={this.state.currentStep}
          next={this._next}
          prev={this._prev}
          goto={this._goto}
          confirm={this._confirm}
          isRenew={this.props.renew}
        >
          {/* renew: {String(this.props.renew)} <br />
          agreeTerms: {String(this.state.agreeTerms)} <br />
          notReceivePromotion: {String(this.state.notReceivePromotion)} <br />
          firstName: {String(this.state.firstName)} <br />
          lastName: {String(this.state.lastName)} <br />
          gender: {String(this.state.gender)} <br />
          address: {String(this.state.address)} <br />
          contactNumber: {String(this.state.contactNumber)} <br />
          email: {String(this.state.email)} <br />
          password: {String(this.state.password)} <br />
          repassword: {String(this.state.repassword)} <br />
          dob: {String(this.state.dob)} <br />
          occupation: {String(this.state.occupation)} <br />
          plan: {String(this.state.plan)} <br />
          planList: {JSON.stringify(this.state.planList)} <br />
          gift: {JSON.stringify(this.state.gift)} <br />

          donationAmount: {String(this.state.donationAmount)} <br />
          donationSendReceipt: {String(this.state.donationSendReceipt)} <br /> */}

          <form onSubmit={this.handleSubmit} style={{width: "100%"}}>
            <Step0
              currentStep={this.state.currentStep}
              handleChange={this.handleChange}
              agreeTerms={this.state.agreeTerms}
              notReceivePromotion={this.state.notReceivePromotion}
              errorMessage={this.state.errorMessage}
            />
            <Step1
              currentStep={this.state.currentStep}
              handleChange={this.handleChange}
              firstName={this.state.firstName}
              lastName={this.state.lastName}
              gender={this.state.gender}
              address={this.state.address}
              contactNumber={this.state.contactNumber}
              email={this.state.email}
              password={this.state.password}
              repassword={this.state.repassword}
              dob={this.state.dob}
              occupation={this.state.occupation}
              errorMessage={this.state.errorMessage}
              renew={this.props.renew}
              resumepay={this.props.resumepay}
              canUpdateDob={this.state.canUpdateDob}
              isExistingMember={this.state.isExistingMember}
            />
            <Step2
              currentStep={this.state.currentStep}
              handleChange={this.handleChange}
              plan={this.state.plan}
              planList={this.state.planList}
              renewalDiscount={this.state.renewalDiscount}
              isPromotionPeriod={this.state.isPromotionPeriod}
            />
            <Step3
              currentStep={this.state.currentStep}
              handleChange={this.handleChange}
              gift={this.state.gift}
              giftReady={this.state.giftReady}
              shippingCostPickup={this.state.shippingCostPickup}
              shippingCostDelivery={this.state.shippingCostDelivery}
              errorMessage={this.state.errorMessage}
              maxTicket={this.state.maxTicket}
            />

            <Step4
              currentStep={this.state.currentStep}
              handleChange={this.handleChange}
              donationAmount={this.state.donationAmount}
              donationSendReceipt={this.state.donationSendReceipt}
            />

            <Step5
              currentStep={this.state.currentStep}
              handleChange={this.handleChange}
              plan={this.state.plan}
              planList={this.state.planList}
              deliveryMethod={this.state.gift.deliveryMethod}
              donationAmount={this.state.donationAmount}
              isPromotionPeriod={this.state.isPromotionPeriod}
              renewalDiscount={this.state.renewalDiscount}
              firstName={this.state.firstName}
              lastName={this.state.lastName}
              address={this.state.address}
              contactNumber={this.state.contactNumber}
              email={this.state.email}
              dob={this.state.dob}
              shippingCostPickup={this.state.shippingCostPickup}
              shippingCostDelivery={this.state.shippingCostDelivery}
            />
          </form>
        </FormLayout>
      </React.Fragment>
    );
  }
}

export default withCookies(
  withRouter(withTranslation("register")(RegisterPage))
);
